
import React from 'react';

const Pricing: React.FC = () => {
  const features = [
    'Centralized administrative control',
    '45+ unified business apps',
    'Mobile device management',
    'Platform capabilities for customization',
    'Industry-standard features',
    'Many apps, one simple invoice'
  ];

  const benefits = [
    {
      title: 'Seamless launch',
      description: 'Our step-by-step onboarding facilitates a smooth transition. Whether you enable five apps or 45, you can scale up without the struggles involved in procuring new software.',
      image: 'https://www.zohowebstatic.com/sites/zweb/images/one/home/seamless-start.png'
    },
    {
      title: 'Dependable support',
      description: 'Enjoy free technical assistance from Zoho, as well as priority support and implementation from either Zoho or our global partner network.',
      image: 'https://www.zohowebstatic.com/sites/zweb/images/one/home/dependable-support.png'
    },
    {
      title: 'Your security, our priority',
      description: 'Along with an uptime of 99.9%, all connections to our servers are required to use Transport Layer Security (TLS 1.2/1.3) encryption with strong ciphers and more.',
      image: 'https://www.zohowebstatic.com/sites/zweb/images/one/home/your-security.png'
    }
  ];

  return (
    <section id="pricing" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Pricing Section */}
        <div className="text-center mb-20">
          <h2 className="text-4xl font-bold text-gray-900 mb-16">
            Unbeatable value. Unbelievable price.
          </h2>
          
          <div className="bg-white rounded-2xl shadow-xl p-8 max-w-4xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div className="text-left">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">All employee pricing</h3>
                <ul className="space-y-4 mb-8">
                  {features.map((feature, index) => (
                    <li key={index} className="flex items-center">
                      <i className="ri-check-line text-green-500 mr-3"></i>
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
                
                <div className="space-y-4">
                  <button className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                    View Plan Details
                  </button>
                  <button className="w-full border border-blue-600 text-blue-600 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors whitespace-nowrap cursor-pointer">
                    View Pricing FAQs
                  </button>
                </div>
              </div>
              
              <div className="text-center">
                <div className="text-6xl font-bold text-blue-600 mb-2">$37</div>
                <p className="text-gray-600 mb-2">/employee/month billed annually</p>
                <p className="text-sm text-gray-500 mb-6">Must purchase license for ALL employees*</p>
                <button className="bg-orange-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer">
                  Know More
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Benefits Section */}
        <div className="mb-20">
          <h2 className="text-4xl font-bold text-gray-900 text-center mb-16">
            Reliable all-in-one solution
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="text-center">
                <div className="mb-6">
                  <img 
                    src={benefit.image}
                    alt={benefit.title}
                    className="w-32 h-32 mx-auto object-contain"
                  />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{benefit.title}</h3>
                <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
